'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import invariant from 'react-utils/invariant';
/* eslint-disable no-console */

export function logError(err) {
  if (console.error && err instanceof Error) {
    console.error(err);
  } else {
    console.log(err);
  }
}

var LocalStorageCache = /*#__PURE__*/function () {
  function LocalStorageCache(_ref) {
    var storageKey = _ref.storageKey;

    _classCallCheck(this, LocalStorageCache);

    invariant(storageKey, 'Storage key must be supplied to LocalStorageCache');
    this._storageKey = "website-grader-ui/" + storageKey;
  }

  _createClass(LocalStorageCache, [{
    key: "get",
    value: function get() {
      var stored = null;

      try {
        stored = window.localStorage.getItem(this._storageKey);
      } catch (e) {
        logError(e);
      }

      try {
        return JSON.parse(stored);
      } catch (e) {
        void e;
      }

      return stored;
    }
  }, {
    key: "put",
    value: function put(value) {
      var toStore = value;

      try {
        toStore = JSON.stringify(toStore);
      } catch (e) {
        void e;
      }

      try {
        return window.localStorage.setItem(this._storageKey, toStore);
      } catch (e) {
        logError(e);
      }

      return null;
    }
  }, {
    key: "delete",
    value: function _delete() {
      try {
        return window.localStorage.removeItem(this._storageKey);
      } catch (e) {
        logError(e);
      }

      return null;
    }
  }]);

  return LocalStorageCache;
}();

export { LocalStorageCache as default };